import React from 'react';
import { 
    EditButton,
    List, 
    Datagrid,
    TextField, 
    TopToolbar,
    CardActions,
    ListButton,
    Show,
    SimpleShowLayout,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import LinkToCreate from  '../../controls/LinkToCreate';
import moment from 'moment';
import ErrorBoundary from '../../ErrorBoundary';

const useStyles = makeStyles({

    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
    inlineBlockLeft: {
        display: 'inline-flex',
        float:    'left', 
        marginRight: '1rem' 
    },
    hidden : {
        display: 'none' 
    },
    inputStyle : {
        width :'20px',
    },
    controlInputStyle : {
       width :'70px',
       fontSize: '8'
   },
    labelStyle : {
       width :'40px',
       backgroundColor: 'silver'
   },
   iniLabelStyle : {
       width :'20px',
       backgroundColor: 'silver'
   },
   dateStyle : {
       width: '120px',
       
   },
   tableStyle :{ 
       margin: 'auto',  
       fontSize:'12px', 
       cellSpacing:"3", 
       cellPadding:"1", 
       border:'1px solid  black', 
       borderCollapse: "collapse", 
       width: "100%"
   },
   th:{
    border:'1px solid  black', 
    textAlign: 'center'
   },
   td:{
    border:'1px solid  black',
    fontWeight:'normal', 
   },
   tdNoBorder:{
    fontWeight:'normal', 
   },

   h3: {
       textAlign: 'center',
       width: '100%'
   },
   clearTableStyle :{ 
       margin: 'auto',  
       fontSize:'12px', 
       fontWeight:'bold', 
       cellspacing:"3", 
       border:'0px solid  black', 
       width: "100%"
   },
   inlineBlock: {
       display: 'inline-flex',
       margin: '5px',
       padding: '5px',
   },


});


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CalActions = ({...props}) => (
    <CardActions style={cardActionStyle}>
        <LinkToCreate id={props.filterValues.ins_id} name='Create' path='/main_AURORA_m/create' />
        <ListButton basePath={'/maiinstrument'} label="Maintenance List" />
    </CardActions>
);


const Editable = ({record}) => {
    //console.log(record.editable);
    return record && record.is_qa > 0 ? '' : <EditButton  record={record} label='Update'/> ;
}

const ShowDetails = ({...props}) => {
    const classes = useStyles();
    var readings = [];
    var record = props && props.record;

    //console.log(props.record)
    if(props && props.record && props.record.readings){
        try{
          readings =JSON.parse(props.record.readings) 
        } catch(e) {
          readings = props.record.readings;
        };
    }

    return(
            <table className={classes.clearTableStyle} >
            <tbody  > 
                <tr>
                    <td>
                    <table className={classes.clearTableStyle}>
                        <tbody>
                            <tr>
                                <td colSpan={6} ><center><h3>REFRACTOMETER</h3></center></td>
                            </tr>
                            <tr>
                                <td>Center Name:</td><td><TextField source='center'  label=''  /></td>
                                <td>Aurora ID#: </td><td><TextField source='eq_id'  label='' /></td>
                                <td>Month/Year: </td><td><MonthYear record={props && props.record}  label='' /></td>
                            </tr>
                        </tbody>
                    </table>
                    </td>
                </tr>
                <tr>
                    <td  colSpan={6}>
                        <table  className={classes.tableStyle} >
                        <tr>
                            <th  className={classes.th} >Monthly Maintenance</th>
                            <th  className={classes.th}>Tech Initial/Date</th>
                            <th  className={classes.th}>QA Review Initial/Date</th>
                        </tr>
                        <tr>
                            <td className={classes.td}>Cleaning of Reservoir channel, Hb detector guide, air detector channel</td>
                            <td className={classes.td}><InitDate init={record && record.cr_tech_init} dt={record && record.cr_tech_dt} label='' /></td>
                            <td className={classes.td}><InitDate init={record && record.cr_qa_init} dt={record && record.cr_qa_dt} label='' /></td>
                        </tr>
                        <tr>
                            <td className={classes.td}>Cleaning of  Pump roller and verification of free turning of pump rollers and replacements of worn or loose components if necessary</td>
                            <td className={classes.td}><InitDate init={record && record.cp_tech_init} dt={record && record.cp_tech_dt} label='' /></td>
                            <td className={classes.td}><InitDate init={record && record.cp_qa_init} dt={record && record.cp_qa_dt} label='' /></td>
                        </tr>
                        <tr>
                            <td className={classes.td}>Inspection of transducer Luers for blockage or damage to the outside surface</td>
                            <td className={classes.td}><InitDate init={record && record.it_tech_init} dt={record && record.it_tech_dt} label='' /></td>
                            <td className={classes.td}><InitDate init={record && record.it_qa_init} dt={record && record.it_qa_dt} label='' /></td>
                        </tr>
                        <tr>
                            <td className={classes.td}>Removal and cleaning of lower air filter</td>
                            <td className={classes.td}><InitDate init={record && record.rm_tech_init} dt={record && record.rm_tech_dt} label='' /></td>
                            <td className={classes.td}><InitDate init={record && record.rm_qa_init} dt={record && record.rm_qa_dt} label='' /></td>
                        </tr>
                        <tr>
                            <td colSpan={3} className={classes.td}>
                                Comments: {record && record.comments}<p></p>
                            </td>
                        </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td className={classes.tdNoBorder}><b>Monthly QA Rreview:</b>&nbsp;<InitDate init={record && record.m_qa_init} dt={record && record.m_qa_dt} label='' /></td>
                </tr>
            </tbody>
        </table>
    )
}

const PostShowActions = () => (
    <TopToolbar>
        <></>
    </TopToolbar>
);

const View= props =>(
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
        actions={<PostShowActions />}
    >
        <SimpleShowLayout   >
            <ShowDetails  />    
        </SimpleShowLayout>
    </Show>
);

const InitDate= ({init, dt})=>(
    dt ? 
   <>
    {init + ' on ' + moment(dt).format('MM/DD/YYYY')}
   </> : <>{init}</>
)
const MonthYear=({record})=>(
    record && record.month && record.year ? 
    <>
    {record.month + '/' + record.year}
    </>: ''
)

const QAInitDate= ({record})=>(
    record && record.qa_date ? 
   <>
    {record.qa_init + ' on ' + moment(record.qa_date).format('MM/DD/YYYY')}
   </> : <>{record.qa_init}</>
)

export const InsList = ({...props }) => (
<ErrorBoundary>  
    <List 
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        actions={<CalActions/>} 
        title ="Maintenance | AURORA | Monthly"
        >
        <Datagrid  expand={<View  {...props}  />} >
            <TextField source="ins_id" label="Aurora ID#" />
            <TextField source="center" label="Center" />
            <MonthYear    label="Month/Year" />
            <Editable />
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default InsList;
